const pillBase = {
    display: 'inline-flex',
    alignItems: 'center',
    px: 0.75,
    py: 0.25,
    borderRadius: '999px',
    fontSize: '0.72rem',
    fontWeight: 600,
    letterSpacing: '0.02em',
    border: 'none',
};

export const active = {
    ...pillBase,
    background: 'linear-gradient(90deg, #00D456, #00D7FF)',
    color: '#00270f',
};

export const inactive = {
    ...pillBase,
    background: 'rgba(255,255,255,0.08)',
    border: '1px solid rgba(255,255,255,0.12)',
    color: 'var(--ecal-lightgrey)',
};
